import { PayloadAction } from "@reduxjs/toolkit";
import { Middleware } from "redux";
import { casesActions } from "../slices";
import { RootState } from "../types";

export const casesMiddleware: Middleware<any, RootState> = ({
  dispatch,
  getState
}) => next => (action: PayloadAction<any>) => {
  const state = getState();

  /* Listen to a 'real' case change and create a snapshot if the case is modified in offline mode.  */
  const isCasesAction = action.type?.startsWith("cases");
  const isModeChangeAction =
    action.type === casesActions.setPublishRequired.type;
  const isShouldSync = action.type === casesActions.setShouldSync.type;

  if (!isCasesAction || isModeChangeAction || isShouldSync) {
    next(action);
    return;
  }

  const isOffline = !state.offline.online;
  const caseId = action?.payload?._id || null;

  if (isOffline && caseId) {
    const caseState = state.cases[caseId];

    if (caseState) {
      const { status } = caseState;
      if (status === "normal") {
        dispatch(
          casesActions.setPublishRequired({
            _id: caseId
          })
        );
      }
    }
  }

  next(action);
};
